/**
 * This stores the Admin App's state. It is kept separate from the Main Root Reducer to help reduce the chances of a conflict.
 */

import { DEVELOPER_TYPES } from '../constants/action-types';

const initialState = {
  dataset: [],
  history: [],
};

export default function developerReducer(state = initialState, action) {
  const newState = {};
  if (DEVELOPER_TYPES[action.type]) {
    newState[DEVELOPER_TYPES[action.type]] = action.payload;
    return Object.assign({}, state, newState);
  }

  return state;
}
